import classNames from 'classnames';
import React from 'react';
import styles from "./FormLayout.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const FormLayout = ({
  children,
  spacing,
  fixedLabels,
  className,
  group,
  margin = true,
  forceGroupOnMobile,
  marginOnLastElement = true
}) => {
  return /*#__PURE__*/_jsx("div", {
    className: classNames(styles.formLayout, group && styles.group, forceGroupOnMobile && styles.forceGroupOnMobile, spacing && styles.spacing, fixedLabels && styles.fixedLabels, margin && styles.margin, marginOnLastElement && styles.marginOnLastElement, className),
    children: children
  });
};